import { IsNotEmpty } from 'class-validator';
import { SelfAppCategoryTimeSeriesEntity } from '../../../../src/core/domain/entities/app-category-metrics/self-app-category-time-series.entity';
import { SelfAppCategoryTimeSeriesData } from '../../../../src/interface/dtos/app-category-metrics/get-self-app-category-time-series.response.dto';
import { Mapper } from '../../../common/ddd/mapper.base';
import { IAnalyticsActivityEnum } from '../../../common/enum/analytics-activity/analytics-activity.enum';

export class SelfAppCategoryTimeSeriesPersistenceResponse {
  @IsNotEmpty()
  [IAnalyticsActivityEnum.LocalStartTime]: string;

  @IsNotEmpty()
  [IAnalyticsActivityEnum.TotalDuration]: string;
}

export class SelfAppCategoryTimeSeriesEntityMapper
  implements
    Mapper<SelfAppCategoryTimeSeriesEntity, SelfAppCategoryTimeSeriesData>
{
  toDomain(
    record: SelfAppCategoryTimeSeriesPersistenceResponse
  ): SelfAppCategoryTimeSeriesEntity {
    return SelfAppCategoryTimeSeriesEntityMapper.toDomain(record);
  }
  static toDomain(
    record: SelfAppCategoryTimeSeriesPersistenceResponse
  ): SelfAppCategoryTimeSeriesEntity {
    const entity = SelfAppCategoryTimeSeriesEntity.create({
      duration: Number(record[IAnalyticsActivityEnum.TotalDuration]),
      date: String(record[IAnalyticsActivityEnum.LocalStartTime]),
    });
    return entity;
  }

  toResponse(
    entity: SelfAppCategoryTimeSeriesEntity
  ): SelfAppCategoryTimeSeriesData {
    return SelfAppCategoryTimeSeriesEntityMapper.toResponse(entity);
  }

  static toResponse(
    entity: SelfAppCategoryTimeSeriesEntity
  ): SelfAppCategoryTimeSeriesData {
    return {
      date: entity.date.split('T')[0],
      value: entity.duration,
    };
  }
}
